export default function videoCtrl() {
	const playBtn = document.getElementById("videoPlay");
	const bg = document.querySelector(".block-skewVideo__bg");
	const videoFrame = document.getElementById("videoFrame");
	const closeBtn = document.getElementById("closeVideo");
	const bgVideo = document.querySelector(".videoOpenBg");
	const htmlElement = document.querySelector("html");
	const iFrame = document.querySelector(".videoFrame iframe");
	const source = iFrame.src;

	playBtn.addEventListener("click", () => {
		if (iFrame.src === "") {
			iFrame.src = source;
		}
		videoFrame.classList.add("show");
		bgVideo.classList.add("show");
		htmlElement.classList.add("noscroll");
	});

	closeBtn.addEventListener("click", () => {
		videoFrame.classList.remove("show");
		bgVideo.classList.remove("show");
		htmlElement.classList.remove("noscroll");
		let stopVideo = new Promise(function(resolve, reject) {
			resolve((iFrame.src = ""));
		});
		stopVideo.then((iFrame.src = source));
	});
}
